type AssetTranslationLike = {
  locale?: string | undefined;
  description?: string | undefined;
};

const normalizeLocale = (locale?: string | null) => locale?.trim().toLowerCase();

const getLanguageCode = (locale?: string | null) => normalizeLocale(locale)?.split(/[-_]/)[0];

const hasDescription = (translation?: AssetTranslationLike) =>
  typeof translation?.description === 'string' && translation.description.trim().length > 0;

const findByExactLocale = (
  translations: AssetTranslationLike[],
  locale?: string | null,
) => {
  const normalizedLocale = normalizeLocale(locale);
  if (!normalizedLocale) {
    return undefined;
  }

  return translations.find((translation) =>
    hasDescription(translation) && normalizeLocale(translation.locale) === normalizedLocale,
  );
};

const findByLanguageCode = (
  translations: AssetTranslationLike[],
  locale?: string | null,
) => {
  const languageCode = getLanguageCode(locale);
  if (!languageCode) {
    return undefined;
  }

  return translations.find((translation) =>
    hasDescription(translation) && getLanguageCode(translation.locale) === languageCode,
  );
};

export const getAssetDescription = (
  translations: AssetTranslationLike[] | null | undefined,
  locale?: string | null,
  fallbackLocale = 'en',
) => {
  if (!translations?.length) {
    return undefined;
  }

  return (
    findByExactLocale(translations, locale)?.description ??
    findByLanguageCode(translations, locale)?.description ??
    findByExactLocale(translations, fallbackLocale)?.description ??
    findByLanguageCode(translations, fallbackLocale)?.description
  );
};
